import { jsx as _jsx } from "react/jsx-runtime";
import { Editor, useEditorRef } from "sprout-ui-dom";
const PostPageCommentText = (props)=>{
    const { comment  } = props;
    const { text  } = comment;
    const editorRef = useEditorRef();
    return /*#__PURE__*/ _jsx(Editor, {
        mode: "SIMPLE",
        readOnly: true,
        initialState: text,
        ref: editorRef
    });
};
export default PostPageCommentText;
